import { createBrowserRouter } from 'react-router-dom'

import DashboardFrame from '../pages/common/DashboardFrame'
import ForgotPassword from '../pages/common/ForgotPassword'
import Login from '../pages/common/Login'
import Root from '../pages/common/Root'

const router = createBrowserRouter([
  {
    path: '',
    element: <Root />,
    children: [
      {
        path: 'login',
        element: <Login />,
      },
      {
        path: 'forgot-password',
        element: <ForgotPassword />,
      },
      {
        path: 'dashboard',
        element: <DashboardFrame />,
      },
    ],
  },
])

export default router
